import { DEFAULT_ADVANCED_SETTINGS } from '../../../../_components/AdvancedSettings/shared'

import type { MusicGeneratorFormValuesNew } from '../../../_types/form'
import type { AdvancedSettingsValue } from '../../../../_components/AdvancedSettings/shared'

type MusicGeneratorAdvancedInput = Partial<AdvancedSettingsValue>

type MusicGeneratorFormValuesInput = Omit<
  Partial<MusicGeneratorFormValuesNew>,
  'advanced'
> & {
  advanced?: MusicGeneratorAdvancedInput
}

export function normalizeMusicGeneratorFormValues(
  values?: MusicGeneratorFormValuesInput | null,
): Partial<MusicGeneratorFormValuesNew> {
  if (!values) {
    return {
      advanced: DEFAULT_ADVANCED_SETTINGS,
    }
  }

  return {
    ...values,
    advanced: {
      ...DEFAULT_ADVANCED_SETTINGS,
      ...values.advanced,
    },
  }
}
